import "../assets/css/error.css"
import img from "../assets/images/wait.gif"

export default function Loading() {
    return(
        <div id="main-site">
            <div className="fof">
                <img src={img} alt="waiting"></img>
            </div>
        </div>
    )
}